import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';

/**
 * `scans.list` is a shell holding the Active / Archived toggle and an outlet;
 * Active is the default landing tab, so `/scans/list` never renders on its own.
 */
class ScansListIndexRoute extends Route {
  @service declare router: RouterService;

  beforeModel() {
    this.router.transitionTo('scans.list.active');
  }
}

export default instrumentRoutePerformance(ScansListIndexRoute);
